"use client";

import { useCookieConsent } from "@/contexts/CookieConsentContext";

/** Opens the cookie banner straight into Manage choices. Rendered in the footer bottom bar. */
export function CookieSettingsButton() {
  const { openManageChoices } = useCookieConsent();
  return (
    <button
      type="button"
      onClick={openManageChoices}
      className="text-base-white text-sm underline-offset-2 transition-colors duration-200 hover:underline"
    >
      Cookie Settings
    </button>
  );
}

export default CookieSettingsButton;
